import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=531112f4&scoped=true&"
import script from "./InputText.vue?vue&type=script&lang=js&"
export * from "./InputText.vue?vue&type=script&lang=js&"
import style0 from "./InputText.vue?vue&type=style&index=0&lang=css&"
import style1 from "./InputText.vue?vue&type=style&index=1&id=531112f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531112f4",
  null
  
)

export default component.exports